import { Component, ChangeDetectionStrategy, Type } from '@angular/core';
import { FieldType, FieldTypeConfig, FormlyFieldConfig } from '@ngx-formly/core';
import { FormlyAttributeEvent } from '@ngx-formly/core/lib/models';
import { CalendarView } from '@progress/kendo-angular-dateinputs';
import { BaseFormlyFieldProps } from '../form-field/public_api';
import { isDate, parseDateAsUTC } from '../../api/common';

interface DatepickerProps extends BaseFormlyFieldProps {
    format?: string;
    activeView?: CalendarView;
    bottomView?: CalendarView;
    minDate?: Date;
    maxDate?: Date;
    valueChange?: FormlyAttributeEvent;
}

export interface FormlyDatepickerFieldConfig extends FormlyFieldConfig<DatepickerProps> {
    type: 'kendo-datepicker' | Type<FormlyFieldDatepicker>;
}

@Component({
    selector: "formly-field-kendo-datepicker",
    template: `
    <kendo-datepicker 
        [formControl]="formControl" 
        [formlyAttributes]="field"
        [format]="props.format"
        (valueChange)="onValueChange(field, $event)">
    </kendo-datepicker>
  `,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormlyFieldDatepicker extends FieldType<FieldTypeConfig<DatepickerProps>> {

    //override defaultOptions = {
    //    hooks: {
    //        onInit: (field: FormlyFieldConfig) => {
    //            const value = field.formControl.value as string;

    //            if (value) {

    //                const date = parseDateAsUTC(value);

    //                if (isDate(date)) {
    //                    field.formControl.setValue(date);
    //                }
    //            }
    //        }
    //    }
    //};

    onValueChange(field: FormlyFieldConfig, value: Date) {
        const props = this.field.props as DatepickerProps;
        
        props.valueChange && props.valueChange(field, value)
    }
}
